import { styled } from '@fluentui/react';
import { VerticalBarChartLoadingAnimationBase } from './vertical-bar-chart-loading-animation.base';
import { getverticalBarChartAnimationSyles } from './vertical-bar-chart-loading-animation.styles';
export const VerticalBarChartLoadingAnimation = styled(VerticalBarChartLoadingAnimationBase, getverticalBarChartAnimationSyles, undefined, {
    scope: 'VerticalBarChartLoadingAnimation',
}, true);
//# sourceMappingURL=vertical-bar-chart-loading-animation.js.map